import Vue from 'vue'
import { HTTP } from '@/utils/httpCommonUtil'
import flatPickr from 'vue-flatpickr-component';
import { BallPulseLoader } from 'vue-loaders';
import VueSimpleSpinner from 'vue-simple-spinner'
import format from 'date-fns/format'
import { getRestParamErrorMessage, getRestResponseErrorMessage } from '@/utils/serverErrorMessageUtil';
import { convertDateStringToUTCDate } from '@/utils/dateUtil';
import MaskedInput from 'vue-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

export default Vue.component('mileage-rates-card', {
  name: 'MileageRatesCard',
  data () {
    let color: any
    return {
      msg: 'MileageRatesCard',
      cardExpanded: false,
      color: color,
      loadingMileageRateData: false,
      mileageRatesErrorMessage: '',
      mileageRateData: [ { id: 1, start_date: '', oldStartDate: '', end_date: '', oldEndDate: '', rate: '', oldRate: '', isEditing: true, isSaving: false} ],
      mileageRateMask: createNumberMask({
        prefix: '',
        allowDecimal: true,
        decimalLimit: 3, 
        integerLimit: 1
      }),
      testNumber: '123.3445'
    }
  },
  components: {
    flatPickr,
    VueSimpleSpinner,
    BallPulseLoader,
    MaskedInput
  },
  filters: {
    dateformat (dateISO: string) {
      let tempString: string = format(dateISO, 'MMM D, YYYY');
      return tempString;
    },
    currency: {
      read: function (value: any) {
        return '$' + value.toFixed(3)
      },
      write: function (value: any) {
        const toCheck = +value.replace(/[^\d.]/g, '');
        return isNaN(toCheck) ? 0 : toCheck;
      }
    } as any
  },
  created: function () {
    this.mileageRateData = [];
  },
  methods: {
    expandCard () {
      (this as any).cardExpanded = !(this as any).cardExpanded;
      if ((this as any).cardExpanded) {
        (this as any).getMileageRates()
      }
    },
    getMileageRates () {
      let self = this as any;
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingMileageRateData = true;
      }, 0);
      self.mileageRatesErrorMessage = ''
      HTTP.get('/api/mileageRates/')
      .then(function (response) {
        let mileageRates = response.data.data;
        mileageRates.map(function (mileageRate: any) { 
          mileageRate.isEditing = false; 
          mileageRate.isSaving = false; 
          mileageRate.rate = mileageRate.rate.toFixed(3);
          mileageRate.start_date = convertDateStringToUTCDate(mileageRate.start_date);
          mileageRate.end_date = convertDateStringToUTCDate(mileageRate.end_date);
        });
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingMileageRateData = false;
        self.mileageRateData = mileageRates;
      })
      .catch(function (error) {
        console.log('response Error!');
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingMileageRateData = false;
        self.mileageRatesErrorMessage = error;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred getting the mileage rates.',
          duration: 5000
        });
      })
    },
    addMileageRate () {
      let currentISODate = new Date().toISOString();
      (this as any).mileageRateData.push(
        { id: +('-' + new Date().getTime()), rate: '', oldRate: '', oldStartDate: currentISODate, start_date: currentISODate, oldEndDate: currentISODate, end_date: currentISODate, isEditing: true, isSaving: false}
      );
    },
    editMileageRate (mileageRate: any) {
      mileageRate.oldRate = mileageRate.rate;
      mileageRate.oldStartDate = mileageRate.start_date;
      mileageRate.oldEndDate = mileageRate.end_date;
      mileageRate.isEditing = !mileageRate.isEditing;
    },
    cancelEditMileageRate (mileageRate: any) {
      if (mileageRate.id < 0) {
        let index = (this as any).mileageRateData.indexOf(mileageRate);
        (this as any).mileageRateData.splice(index, 1);
      }
      mileageRate.oldRate = mileageRate.oldRate;
      mileageRate.start_date = mileageRate.oldStartDate;
      mileageRate.end_date = mileageRate.oldEndDate;
      mileageRate.isEditing = !mileageRate.isEditing;
    },
    saveEditMileageRate (mileageRate: any) {
      let self = this as any;
      mileageRate.isSaving = true;
      // If the mileageRate's ID is negative, it has not yet been saved to the DB. Request a "Create". 
      if (mileageRate.id < 0) {
        HTTP.post('/api/mileageRates/',{
          'start_date': mileageRate.start_date,
          'end_date': mileageRate.end_date,
          'rate': parseFloat(mileageRate.rate)
        })
        .then(function (response) {
          self.getMileageRates();
          mileageRate.oldRate = mileageRate.rate;
          mileageRate.oldStartDate = mileageRate.start_date;
          mileageRate.oldEndDate = mileageRate.end_date;
          mileageRate.isEditing = !mileageRate.isEditing;
          mileageRate.isSaving = false;
        })
        .catch(function (error) {
          console.log('response Error!');
          self.mileageRatesErrorMessage = error;
          mileageRate.isSaving = false;
          
          let errorMessages = [];
          let noErrorsFound = true;
          errorMessages.push( getRestParamErrorMessage(error, 'start_date') );
          errorMessages.push( getRestParamErrorMessage(error, 'end_date') );
          errorMessages.push( getRestParamErrorMessage(error, 'rate') );
          errorMessages.forEach(function (errorMessage) {
            if (!errorMessage.length) { return; }
            noErrorsFound = false;
            self.$notify({
              group: 'main',
              type: 'error',
              title: 'Error',
              text: errorMessage,
              duration: 5000
            });           
          });
          if (noErrorsFound) {            
            let generalError = getRestResponseErrorMessage(error);
            self.$notify({
              group: 'main',
              type: 'error',
              title: 'Error',
              text: generalError ? generalError : 'An error occurred add the mileage rate.',
              duration: 5000
            });
          }         
        })
      } else {
        // Else request an update to an existing MileageRate in the DB.
        HTTP.put('/api/mileageRates/',{
          'id': mileageRate.id,
          'start_date': mileageRate.start_date,
          'end_date': mileageRate.end_date,
          'rate': mileageRate.rate
        })
        .then(function (response) {
          self.getMileageRates();
          mileageRate.oldRate = mileageRate.rate;
          mileageRate.oldStartDate = mileageRate.start_date;
          mileageRate.oldEndDate = mileageRate.end_date;
          mileageRate.isEditing = !mileageRate.isEditing;
          mileageRate.isSaving = false;
        })
        .catch(function (error) {
          console.log('response Error!');
          self.mileageRatesErrorMessage = error;
          mileageRate.isSaving = false;
          
          let errorMessages = [];
          let noErrorsFound = true;
          errorMessages.push( getRestParamErrorMessage(error, 'start_date') );
          errorMessages.push( getRestParamErrorMessage(error, 'end_date') );
          errorMessages.push( getRestParamErrorMessage(error, 'rate') );
          errorMessages.forEach(function (errorMessage) {
            if (!errorMessage.length) { return; }
            noErrorsFound = false;
            self.$notify({
              group: 'main',
              type: 'error',
              title: 'Error',
              text: errorMessage,
              duration: 5000
            });           
          });
          if (noErrorsFound) {            
            let generalError = getRestResponseErrorMessage(error);
            self.$notify({
              group: 'main',
              type: 'error',
              title: 'Error',
              text: generalError ? generalError : 'An error occurred editing the mileage rate.',
              duration: 5000
            });
          }
        })
      }
    },
    deleteMileageRate (mileageRate: any) {
      let self = this as any;
      let deleteSpinnerTimeout = setTimeout(function () {
        self.loadingMileageRateData = true;
      }, 500);
      HTTP.delete('/api/mileageRates/' + mileageRate.id)
      .then(function (response) {
        self.getMileageRates();
        clearTimeout(deleteSpinnerTimeout);
        self.loadingMileageRateData = false;
      })
      .catch(function (error) {
        console.log('response Error!');
        self.mileageRatesErrorMessage = error;
        clearTimeout(deleteSpinnerTimeout);
        self.loadingMileageRateData = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred deleting the mileage rate.',
          duration: 5000
        });      
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/settings/cards/mileageRates/MileageRatesCard.ts